(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
  	constructor() {
  		super();
  		this.elements = {
  			input: this.querySelector(
  				'input[name="locale_code"], input[name="country_code"]'
  			),
  			button: this.querySelector('button'),
  			panel: this.querySelector('ul'),
  		};
  		this.elements.button.addEventListener(
  			'click',
  			this.openSelector.bind(this)
  		);
  		this.elements.button.addEventListener(
  			'focusout',
  			this.closeSelector.bind(this)
  		);
  		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

  		this.querySelectorAll('a').forEach((item) =>
  			item.addEventListener('click', this.onItemClick.bind(this))
  		);
  	}

  	hidePanel() {
  		this.elements.button.setAttribute('aria-expanded', 'false');
  		this.elements.panel.setAttribute('hidden', true);
  	}

  	onContainerKeyUp(event) {
  		if (event.code.toUpperCase() !== 'ESCAPE') return;

  		this.hidePanel();
  		this.elements.button.focus();
  	}

  	onItemClick(event) {
  		event.preventDefault();
  		this.elements.input.value = event.currentTarget.dataset.value;
  		this.querySelector('form')?.submit();
  	}

  	openSelector() {
  		this.elements.button.focus();
  		this.elements.panel.toggleAttribute('hidden');
  		this.elements.button.setAttribute(
  			'aria-expanded',
  			(
  				this.elements.button.getAttribute('aria-expanded') === 'false'
  			).toString()
  		);
  	}

  	closeSelector(event) {
  		const shouldClose =
  			event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  		if (event.relatedTarget === null || shouldClose) {
  			this.hidePanel();
  		}
  	}
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);

    var oldScrollY = window.scrollY;
    var directionText = document.body;
    var directionContainer = document.documentElement;

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
          let checkOverflow = directionText.style.overflow;
          if(checkOverflow == "hidden"){
            directionContainer.classList.add("overflow-hidden");
          }else{
            directionContainer.classList.remove("overflow-hidden");
          }
        });    
    });
    
    var target = directionText;
    observer.observe(target, { attributes : true, attributeFilter : ['style'] });
  
    window.onscroll = function(e) {
      if(oldScrollY < window.scrollY){
          directionText.setAttribute("scroll-direction", "down");
      } else {
          directionText.setAttribute("scroll-direction", "up");
      }
      oldScrollY = window.scrollY;
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

// Detect the specific Judge.me request (works for fetch and XHR)
(() => {
  const JUDGEME_RE = /https:\/\/api\.judge\.me\/reviews\/reviews_for_widget/i;

  // Dispatch helpers
  const fire = (name, detail) =>
    window.dispatchEvent(new CustomEvent(name, { detail }));

  // --- Intercept fetch ---
  if (window.fetch) {
    const _fetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      const isTarget = JUDGEME_RE.test(url);
      if (isTarget) fire('judgeme:ajax:start', { url, via: 'fetch' });
      const res = await _fetch(...args);
      if (isTarget) fire('judgeme:ajax:finish', { url, status: res.status, via: 'fetch' });
      return res;
    };
  }

  // --- Intercept XHR ---
  if (window.XMLHttpRequest) {
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__jm_url = url;
      return _open.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function(...args) {
      const url = this.__jm_url || '';
      const isTarget = JUDGEME_RE.test(url);
      if (isTarget) fire('judgeme:ajax:start', { url, via: 'xhr' });

      this.addEventListener('loadend', () => {
        if (isTarget) fire('judgeme:ajax:finish', { url, status: this.status, via: 'xhr' });
      });

      return _send.apply(this, args);
    };
  }
})();

window.addEventListener('judgeme:ajax:start',  e => console.log('JM START',  e.detail));
window.addEventListener('judgeme:ajax:finish', e => resturtureJDGMReview());


function resturtureJDGMReview(){
  let jdgmReviewWrapper = document.querySelector(".jdgm-rev-widg__reviews");
  let jdgmReviews = jdgmReviewWrapper.querySelectorAll(".jdgm-rev");

  jdgmReviews.forEach(function(jdgmReview){
      let actionBlock = jdgmReview.querySelector(".jdgm-rev__actions");
      let titleBlock = jdgmReview.querySelector(".jdgm-rev__title");
      let reviewBody = jdgmReview.querySelector(".jdgm-rev__body");
      let reviewImgs = jdgmReview.querySelectorAll(".jdgm-rev__pic-img");
      let reviewForm = jdgmReview.querySelector(".jdgm-rev__custom-form");

      reviewBody.prepend(titleBlock);
      reviewBody.append(actionBlock);
      
      setTimeout(() => {
        let jdgmRevHeader = jdgmReview.querySelector(".jdgm-rev__header");
        let ratingBlock = jdgmRevHeader.querySelector(".jdgm-row-rating");
        reviewBody.prepend(ratingBlock);
        jdgmRevHeader.append(reviewForm);

        console.log({jdgmRevHeader})
        console.log({ratingBlock})

        let reviewImgs = jdgmReview.querySelectorAll("img");
        console.log({reviewImgs}, reviewImgs.length)
        if(reviewImgs.length > 0){
          reviewImgs.forEach(function(reviewImg){
            let imgSrc = reviewImg.getAttribute("data-src");
            imgSrc = imgSrc.split("?")[0];
            console.log({imgSrc})
            reviewImg.setAttribute("data-src", imgSrc);
            reviewImg.setAttribute("src", imgSrc);
          })
        }
      }, 1000);
  })
}
function checkIfJudgemeWidgetLoaded() {
  const judgeMeWidget = document.querySelector('#judgeme_product_reviews'); // Or the specific ID if available, e.g., '#judgeme_product_reviews'
  if (judgeMeWidget) {
    console.log('Judge.me widget is loaded.');
    judgeMeWidget.querySelector("select.jdgm-sort-dropdown").addEventListener("input", function(){
      observeJudgemeWidgetLoad();
    })

    
    return true;
  } else {
    console.log('Judge.me widget is not yet loaded.');
    return false;
  }
}

function observeJudgemeWidgetLoad() {
  const targetNode = document.body; // Observe changes in the entire body
  const config = { childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const judgeMeWidget = document.querySelector('.jdgm-rev-widg__body');
        if (judgeMeWidget) {
          console.log('Judge.me widget detected via MutationObserver.');
          resturtureJDGMReview();
          observer.disconnect(); // Stop observing once found
          // Perform actions that depend on the widget being loaded
          return;
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// Start observing when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  observeJudgemeWidgetLoad();
});

// Call the function after the DOM is ready, or use a MutationObserver for dynamic loading
document.addEventListener('DOMContentLoaded', () => {
  checkIfJudgemeWidgetLoaded();
});

class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
